const pickAdCreativeName = (data) => {
  if (data?.ad_name?.trim()) {
    return data.ad_name.trim();
  }
  if (data?.creative_name?.trim()) {
    return data.creative_name.trim();
  }
  return null;
};

export const getPixelCreativeName = (pixelTracking) => {
  if (pixelTracking?.trackingData) {
    try {
      const data = JSON.parse(pixelTracking.trackingData);
      const fromTracking = pickAdCreativeName(data);
      if (fromTracking) {
        return fromTracking;
      }
    } catch (_) {
      // ignore invalid tracking data
    }
  }

  if (pixelTracking?.creativeName?.trim()) {
    const stored = pixelTracking.creativeName.trim();
    if (pixelTracking?.trackingData) {
      try {
        const data = JSON.parse(pixelTracking.trackingData);
        if (data?.campaign_name?.trim() === stored) {
          return null;
        }
      } catch (_) {
        // ignore invalid tracking data
      }
    }
    return stored;
  }

  return null;
};

export const getLeadCreativeName = (lead) => pickAdCreativeName(lead);

export const getPixelCampaignName = (pixelTracking) => {
  if (pixelTracking?.trackingData) {
    try {
      const data = JSON.parse(pixelTracking.trackingData);
      if (data?.campaign_name?.trim()) {
        return data.campaign_name.trim();
      }
    } catch (_) {
      // ignore invalid tracking data
    }
  }

  return null;
};

export const getLeadCampaignName = (lead) => lead?.campaign_name?.trim() || null;

export const getLeadAdId = (leadOrTracking) => {
  if (leadOrTracking?.ad_id?.trim()) {
    return leadOrTracking.ad_id.trim();
  }

  const trackingData = leadOrTracking?.trackingData;
  if (!trackingData) {
    return leadOrTracking?.utm_content?.trim() || null;
  }

  try {
    const data = JSON.parse(trackingData);
    return data?.ad_id?.trim() || data?.utm_content?.trim() || null;
  } catch (_) {
    return null;
  }
};
